import React, { Component } from 'react';
import { Table, Tooltip, Button, Card, Select, Input, Row, Col, Icon, Spin } from 'antd';
import UsuariosRequest from '../../services/Usuarios'
import { openNotification } from '../../util/notificaciones';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { roles } from '../../util/Roles';
import CatalogoRequest from '../../services/Catalogo';
import FormUsuarios from './FormUsuarios';
import moment from 'moment'
import 'moment/locale/es';
import { getSegmento } from '../../util/generics';
moment.locale('es')
const { Option } = Select;


/**
 * Clase para los usuarios
 */
export default class Usuarios extends Component {
    state = {
        arrUsuarios: [],
        arrUsuariosCopy: [],
        arrSucursales: [],
        cargando: false,
        paginacion: {},
        searchNameUser: "",
        usuario_selected: null,
        typeForm: null,
        visible: false,
        disableDeleteFilters: true,
        selectedConfigurado: undefined,
        sucursal_selected: null,
        sitio_selected: null,
        configurado_selected: undefined,
        paginaSiguiente: 1
    }

    /**
    * Comportamiento del componente al recibir nuevos datos
    */
    componentDidMount = () => {
        let state = { ...this.state }
        //Si no tiene el rol de admin o segmento asignado. No lo deja pasar
        if(!ShowMenuItem([roles.Admin]) || !getSegmento()) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            this.setState({ cargando: true }, () => {
                UsuariosRequest.ListarUsuarios().then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    state.arrUsuarios = response.data.results
                    state.arrUsuariosCopy = response.data.results
                    return CatalogoRequest.CargarRegiones()
                }).then(response => {
                    state.cargando = false;
                    state.arrRegiones = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo
                    )
                })
            })
        }
    }

    /**
     * Se ejecuta cuando se busca en el input text
     * @param: text. texto que se pone en el input
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        let buscar = false;
        if (text.trim() !== state.searchNameUser.trim()) buscar = true
        state.searchNameUser = text;
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.applyFilters();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de abrir el modal con el formulario
     * @param: type. tipo del modal que se abrirá
     * @param: record. sitio seleccionado
     * necesita recargar o no los sitios
     */
    showForm = (type, _, record) => {
        let state = { ...this.state }
        state.usuario_selected = record;
        state.typeForm = type;
        state.visible = true;
        this.setState(state)
    }

    /**
     * Función que esconde el modal de estatus
     * @param: value. valor para esconder el modal
     * @return: nada.
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        if (value) {
            state.visible = false;
            state.usuario_selected = null;
            this.setState(state, () => {
                this.applyFilters()
            })
        }
        this.setState({ visible: false, usuario_selected: null })
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursal_selected = null;
        state.region_selected = value
        if (value) {
            CatalogoRequest.CargarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                this.setState(state, this.applyFilters)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error"
                )
            })
        } else {
            this.setState(state, this.applyFilters)
        }
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.sucursal_selected = value
        this.setState(state, this.applyFilters)
    }

    /**
     * Función para asignar el estatus al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    handleChangeEstatus = (value) => {
        let state = { ...this.state };
        state.estatus_selected = value;
        this.setState(state, this.applyFilters)
    }

    /**
     * Función para asignar el estatus al combo configurado
     * @param: value. opción seleccionada
     * @return: nada
     */
    handleChangeConfigurado = (value) => {
        let state = { ...this.state };
        state.configurado_selected = value;
        this.setState(state, this.applyFilters)
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     */
    applyFilters = () => {
        let state = { ...this.state };
        let filtros = {};
        filtros.page = 1;
        if (state.searchNameUser.trim() !== "") filtros.busqueda = state.searchNameUser.trim();
        filtros.region_id = state.region_selected;
        filtros.sucursal_id = state.sucursal_selected;
        filtros.estatus_id = state.estatus_selected === 1 ? true : state.estatus_selected === 2 ? false : undefined
        filtros.configurado_id = state.configurado_selected === 1 ? true : state.configurado_selected === 2 ? false : undefined
        state.cargando = true;

        if (state.searchNameUser.trim() === "" &&
            (!state.region_selected) &&
            (!state.sucursal_selected) &&
            (!state.estatus_selected) &&
            (!state.configurado_selected)
        ) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        this.setState(state, () => {
            UsuariosRequest.ListarUsuarios(filtros)
                .then(response => {
                    state.arrUsuarios = response.data.results;
                    state.arrUsuariosCopy = response.data.results;
                    state.cargando = false;
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar los usuarios.",
                        "Error"
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
     handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        let filtros = {};
        filtros.region_id = state.region_selected;
        filtros.sucursal_id = state.sucursal_selected;
        filtros.estatus_id = state.estatus_selected === 1 ? true : state.estatus_selected === 2 ? false : undefined
        filtros.configurado_id = state.configurado_selected === 1 ? true : state.configurado_selected === 2 ? false : undefined
        if (state.searchNameUser.trim() !== "") filtros.busqueda = state.searchNameUser.trim();
        state.paginaSiguiente = paginaSiguiente
        filtros.page = paginaSiguiente
        this.setState({ cargando: true }, () => {
            UsuariosRequest.ListarUsuarios(filtros)
                .then(response => {
                    state.cargando = false;
                    state.paginacion = {
                        current: paginaSiguiente
                    }
                    state.arrUsuarios = response.data.results
                    state.arrUsuariosCopy = response.data.results
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo ?? 'Error'
                    )
                })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableDeleteFilters = true;
        state.searchNameUser = "";
        state.region_selected = undefined;
        state.sucursal_selected = null;
        state.estatus_selected = undefined;
        state.configurado_selected = undefined;
        this.setState(state, this.applyFilters);
        openNotification("Los filtros se han limpiado correctamente.", "Éxito");
    }

    render() {
        let columnasUsuarios = [
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
            },
            {
                title: "Usuario",
                dataIndex: "usuario",
                key: "usuario",
            },
            {
                title: "Correo",
                dataIndex: "email",
                key: "email",
            },
            {
                title: "Región",
                dataIndex: "region",
                key: "region",
                render: region => (
                    <span>{region ? region.nombre_corto : 'Sin asignar'}</span>
                )
            },
            {
                title: "Sucursal",
                dataIndex: "sucursal",
                key: "sucursal",
                render: sucursal => (
                    <span>{sucursal ? sucursal?.nombre_corto : 'Sin asignar'}</span>
                )
            },
            {
                title: "Estatus",
                dataIndex: "activo",
                key: "activo",
                render: activo => (
                    <span>{activo ? 'Activo' : 'Inactivo'}</span>
                )
            },
            {
                title: "Configurado",
                dataIndex: "configurado",
                key: "configurado",
                render: configurado => (
                    <span>{configurado ? 'Configurado' : 'No configurado'}</span>
                )
            },
            {
                title: "Segmento",
                dataIndex: "segmento",
                key: "segmento",
                render: segmento => (
                    <span>{segmento ? 'Asignado' : 'No asignado'}</span>
                )
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        {record.configurado &&
                            <div>
                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Ver detalle de usuario"}>
                                        <Button icon="eye" className="btnVerCrearGuardar" onClick={() => this.showForm('ver', value, record)}></Button>
                                    </Tooltip>
                                </span>
                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Editar usuario"}>
                                        <Button icon="edit" className="btnEditar" onClick={() => this.showForm('editar', value, record)}></Button>
                                    </Tooltip>
                                </span>
                            </div>
                        }
                        {!record.configurado &&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Configurar usuario"}>
                                    <Button icon="setting" onClick={() => this.showForm('configurar', value, record)}></Button>
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
            }
        ]
        return (
            <Card id="ParentSize"
                title="Usuarios">
                <div className="panel-block">
                    <div className="filters">
                        <Row gutter={[16]}>
                            <Col span={6} >
                                <Tooltip placement="top" title="Buscar sobre todos los resultados">
                                    <div className="center">Búsqueda:</div>
                                    <Input
                                        id="userInput"
                                        type="text"
                                        maxLength={80}
                                        value={this.state.searchNameUser}
                                        autoFocus={true}
                                        placeholder="Buscar por Nombre / Usuario / Correo"
                                        onChange={(e) => this.handleSearchInput(e.currentTarget.value)}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={4}>
                                <Tooltip placement="top" title="Buscar usuario por región">
                                    <div className="center">Región:</div>
                                    <Select
                                        allowClear={true}
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        value={this.state.region_selected}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones?.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={4}>
                                <Tooltip placement="top" title="Buscar usuario por sucursal">
                                    <div className="center">Sucursal:</div>
                                    <Select
                                        allowClear={true}
                                        showSearch
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        style={{ width: "100%" }}
                                        value={this.state.sucursal_selected}
                                        defaultValue={null}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={!this.state.region_selected}
                                        onChange={this.handleChangeSucursal}
                                    >
                                        {/* Opciones de sucursales */}
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales?.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={3} >
                                <Tooltip placement="top" title="Buscar usuario por estatus">
                                    <div className="center">Estatus usuario:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.estatus_selected}
                                        onChange={this.handleChangeEstatus}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        <Option key={1} value={1}>Activo</Option>
                                        <Option key={2} value={2}>Inactivo</Option>
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={3} >
                                <Tooltip placement="top" title="Buscar usuario por estatus configurado">
                                    <div className="center">Configurado:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.configurado_selected}
                                        onChange={this.handleChangeConfigurado}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        <Option key={1} value={1}>Configurado</Option>
                                        <Option key={2} value={2}>No configurado</Option>
                                    </Select>
                                </Tooltip>

                            </Col>
                            <Col span={4} >
                                <div style={{ marginTop: 7 }}>
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button type="default" icon="delete" className={this.state.disableDeleteFilters ? 'disableBtn' : ''} style={{ width: '20%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.1em' }} onClick={this.cleanFilters}></Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            rowClassName={(user) => !user.configurado ? 'back-grey' : ''}
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            pagination={this.state.paginacion}
                            columns={columnasUsuarios}
                            dataSource={this.state.arrUsuariosCopy}
                        />
                    </Spin>
                </div>
                <FormUsuarios
                    esconderModal={this.esconderModal}
                    visible={this.state.visible}
                    modo={this.state.typeForm}
                    usuario_selected={this.state.usuario_selected}
                />
            </Card>
        )
    }
}